import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import Label from "../Label";

type Story = GenericStory<React.ComponentProps<typeof Label>>;

export default {
    title: "Typography/Label",
    component: Label
} as ComponentMeta<typeof Label>;

const Template: Story = args => <Label {...args}>Example text</Label>;

export const Default = Template.bind({});

export const Colored = Template.bind({});
Colored.args = {
    color: "text-error-700"
};

export const Size = Template.bind({});
Size.args = {
    size: "heading-x-small-semibold"
};

export const H1 = Template.bind({});
H1.args = {
    as: "h1"
};
